import { ZIndex } from "@/domains/design/constants";
import { TOP_BAR_HEIGHT } from "@/components/layout/components/constants";
import styled from "@emotion/styled";

export const StyledSidebarWrapper = styled.div<{ $avoidMacOsTrafficLights?: boolean }>`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing["2"]};
  padding-top: ${({ $avoidMacOsTrafficLights, theme }) =>
    $avoidMacOsTrafficLights ? theme.spacing["7"] : theme.spacing["2"]};
  padding-inline: ${({ theme }) => theme.spacing["4"]};
  overflow: hidden;
  height: calc(100dvh - ${TOP_BAR_HEIGHT}px);

  opacity: 1;
  transition:
    opacity 0.25s ease-in-out,
    transform 0.25s ease-in-out;
  flex-shrink: 0;
  z-index: ${ZIndex.Sidebar};
  position: relative;
`;
StyledSidebarWrapper.displayName = "StyledSidebarWrapper";

export const StyledAccountInfoWrapper = styled.div`
  padding-block: ${({ theme }) => theme.spacing["2"]};
  padding-inline: ${({ theme }) => theme.spacing["3"]};
  border-radius: ${({ theme }) => theme.borderRadius.max};

  &:hover:not(:disabled) {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.background.button.chrome.hover};
  }
`;
StyledAccountInfoWrapper.displayName = "StyledAccountInfoWrapper";
